var render = function render(){var _vm=this,_c=_vm._self._c;return _c('recebimento-dados-nivel-1-agrupado',{ref:"nivel_1_cards",on:{"Recebimento__SelecionaItemNivel1":_vm.selectItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }